import React from "react";
import { useAirbnbMessagingPlugin } from "../../hooks/usePlugins";
import { MessageDrawer } from "../Common/MessageModal/MessageDrawer";

interface MessageSelectedEventsModalProps {
    eventIds: ID[];
    onClose: () => void;
    isOpen: boolean;
}

export const MessageSelectedEventsModal = ({ eventIds, onClose, isOpen }: MessageSelectedEventsModalProps) => {
    const airbnbPlugin = useAirbnbMessagingPlugin();

    return (
        <MessageDrawer
            title="Send Group Message"
            filters={{ events: eventIds }}
            isOpen={isOpen}
            description="This message will be sent to all guests of all selected events."
            channels={{ messagingPlugin: airbnbPlugin ?? undefined }}
            onClose={onClose}
        />
    );
};
